export const getColumns = (filters) => {
    return [
        {
            title: 'Mutual Fund',
            dataIndex: 'mutualFund',
            key: 'mutualFund',
            fixed: "left",
            width: 100,
            filterSearch: true,
            filteredValue: filters["mutualFund"],
        },
        {
            title: 'Predict Nav%',
            dataIndex: 'shareNavDiffFromLastDay',
            key: 'shareNavDiffFromLastDay',
            width: 100,
            filteredValue: filters["shareNavDiffFromLastDay"],
            filterSearch: true,
            sorter: true
        },
        {
            title: 'Nav Diff%',
            dataIndex: 'navDiffFromLastDay',
            key: 'navDiffFromLastDay',
            filteredValue: filters["navDiffFromLastDay"],
            filterSearch: true,
            width: 100,
            sorter: true
        },
        {
            title: 'Predict Nav',
            dataIndex: 'shareNavPredict',
            key: 'shareNavPredict',
            width: 100,
            sorter: true
        },
        {
            title: 'Nav',
            dataIndex: 'nav',
            key: 'nav',
            filteredValue: filters["nav"],
            filterSearch: true,
            width: 100,
            sorter: true
        },


        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            filteredValue: filters["date"],
            filterSearch: true,
            // width: 100,
            render: ((d) => {
                return new Date(d).toLocaleDateString()
            }),
            sorter: true
        },
        {
            title: 'Updated At',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            // width: 100,
            sorter: true,
            render: ((d) => {
                return new Date(d).toLocaleString()
            })
        }
    ]
}

export const getGraphQlItems = () => {
    return ['date', 'nav', 'navDiffFromLastDay', 'shareNavDiffFromLastDay', 'shareNavPredict', 'updatedAt', `mutualFund {
        fund_name    
        _id
      }`];
}